var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery"},_vm._l((_vm.images),function(img){return _c('div',{staticClass:"image",style:({backgroundImage:("url(" + (img.src) + ")")})})}))}
var staticRenderFns = []

export { render, staticRenderFns }